import React, { useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { contactSchema } from '../../Validations/contact.validation';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import config from '../../config/config';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';


export const ContactForm = () => {

    const [loading, setLoading] = useState(false)

    const { executeRecaptcha } = useGoogleReCaptcha();

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(contactSchema)
    });

    const onSubmit = async (data) => {
        try {
            if (!executeRecaptcha) {
                console.log('Execute recaptcha not yet available');
                return;
            }

            setLoading(true);

            const token = await executeRecaptcha()

            if (!token) {
                console.log('Captcha inválido');
                setLoading(false);
                return;
            }

            const response = await fetch(`${config.backURL}/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ...data, token }),
            });

            const json = await response.json();
            notify(json.status, json.message);

            reset();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            notify('error', 'Something went wrong! Please try again later or send an email manually.');
        }
    };

    const notify = (value, message) => {
        if (value === 'success') return toast.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "light",
            style: {
                fontSize: '18px'
            }
        })
        return toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "light",
            style: {
                fontSize: '18px'
            }
        })
    };

    return (
        <div className="contactFormCont">
            <form id="contactForm" className="contactForm" onSubmit={handleSubmit(onSubmit)}>
                <div className="contactFormHeader">
                    <h3>Send us a message</h3>
                    <p>All fields are required.</p>
                </div>

                <div className="contactFields">
                    <div className="contactField">
                        <label htmlFor="cf-name">Full name</label>
                        <input {...register('name')} id="cf-name" type="text" name="name" />
                        <p className='error'>{errors.name?.message}</p>
                    </div>

                    <div className="contactField">
                        <label htmlFor="cf-email">Email</label>
                        <input {...register('email')} id="cf-email" type="email" name="email" />
                        <p className='error'>{errors.email?.message}</p>
                    </div>

                    <div className="contactField">
                        <label htmlFor="cf-number">Cellphone</label>
                        <input {...register('number')} id="cf-number" type="tel" name="number" />
                        <p className='error'>{errors.number?.message}</p>
                    </div>

                    <div className="contactField">
                        <label htmlFor="cf-enterprise">Enterprise</label>
                        <input {...register('enterprise')} id="cf-enterprise" type="text" name="enterprise" />
                        <p className='error'>{errors.enterprise?.message}</p>
                    </div>
                </div>

                <div className="contactField">
                    <label htmlFor="cf-subject">Subject</label>
                    <input {...register('subject')} id="cf-subject" type="text" name="subject" />
                    <p className='error'>{errors.subject?.message}</p>
                </div>

                <div className="contactField">
                    <label htmlFor="cf-message">Message</label>
                    <textarea {...register('message')} id="cf-message" name="message" rows="5"></textarea>
                    <p className='error'>{errors.message?.message}</p>
                </div>

                <div className="contactFormFooter">
                    <span>Protected by reCAPTCHA.</span>
                    <input type="submit" className="contactSubmit" disabled={loading}
                        value={loading ? "Sending... Please wait." : "Send message"}
                    />
                </div>
            </form>
            <ToastContainer />
        </div>
    )
}
